export class Colour {
  public constructor(
    public colourId: string,
    public colourTypeDescription: string,
    public colourDescription: string,
    public colourType: string,
    public red: string,
    public green: string,
    public blue: string
  ) {}
}
